import { Box, InputAdornment, Typography } from "@mui/material";
import { TextField } from "app/components/TextField";
import React from "react";

import { useStyles } from "../styles";
import { ProfileFieldProps } from "../types";

const ProfileField = ({
  label,
  value,
  icon,
  type = "text",
  readOnly = true,
  onChange,
  onBlur,
}: ProfileFieldProps) => {
  const styles = useStyles();

  return (
    <Box className={styles.formField}>
      <Typography className={styles.fieldLabel}>{label}</Typography>
      <TextField
        fullWidth
        value={value}
        type={type}
        className={styles.textField}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={onBlur}
        onKeyDown={(event) => {
          if (event.key !== "Enter") return;
          event.preventDefault();
          const field = event.currentTarget.querySelector("input");
          (field ?? (event.target as HTMLElement)).blur();
        }}
        InputProps={{
          readOnly,
          startAdornment: (
            <InputAdornment position="start">{icon}</InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default ProfileField;
